import {get} from '../../utils'

// Action Types

export const actionTypes = {
  INIT_OUTLET_STORE: 'INIT_OUTLET_STORE',
  LOAD_OUTLET_STORE: 'LOAD_OUTLET_STORE',
  STEP_CHANGE: 'STEP_CHANGE',
  DEALER_RESET: 'DEALER_RESET',
  DEALER_CONFIRM: 'DELAER_CONFIRM',
  DEALER_CHANGE_REQUEST: 'DEALER_CHANGE_REQUEST',
  DEALER_CHANGE_SUCCESS: 'DEALER_CHANGE_SUCCESS',
  DEALER_CHANGE_NO_RESULTS: 'DEALER_CHANGE_NO_RESULTS',
  DEALER_FETCH_START: 'DEALER_FETCH_START',
  DEALER_FETCH_CANNOT_RESOLVE: 'DEALER_FETCH_CANNOT_RESOLVE',
  DEALER_FETCH_SUCCESS: 'DEALER_FETCH_SUCCESS',
  DEALER_FETCH_ERROR: 'DEALER_FETCH_ERROR',
  NAMEPLATE_CHANGE: 'NAMEPLATE_CHANGE',
  OUTLET_STOCKS_FETCH_REQUEST: 'OUTLET_STOCKS_FETCH_REQUEST',
  OUTLET_STOCKS_FETCH_START: 'OUTLET_STOCKS_FETCH_START',
  OUTLET_STOCKS_FETCH_SUCCESS: 'OUTLET_STOCKS_FETCH_SUCCESS',
  OUTLET_STOCKS_FETCH_ERROR: 'OUTLET_STOCKS_FETCH_ERROR',
  UPDATE_SORT: 'UPDATE_SORT',
  UPDATE_FILTER: 'UPDATE_FILTER',
}

// Action Creators

const initOutletStore = ({outletStockEndpoint}) => ({
  type: actionTypes.INIT_OUTLET_STORE,
  payload: {outletStockEndpoint},
})

const dealerReset = () => ({
  type: actionTypes.DEALER_RESET,
})

const dealerConfirm = () => ({
  type: actionTypes.DEALER_CONFIRM,
  payload: {dealerConfirm: true},
})

const dealerChangeRequest = ({dealerCode, id}) => ({
  type: actionTypes.DEALER_CHANGE_REQUEST,
  payload: {dealer: {dealerCode, id}, dealerConfirm: false},
})

const stepChange = payload => ({
  type: actionTypes.STEP_CHANGE,
  payload,
})

const nameplateChange = payload => ({
  type: actionTypes.NAMEPLATE_CHANGE,
  payload,
})

const fetchRequest = params => ({
  type: actionTypes.OUTLET_STOCKS_FETCH_REQUEST,
  payload: {...params},
})

const fetchSuccess = result => ({
  type: actionTypes.OUTLET_STOCKS_FETCH_SUCCESS,
  payload: {...result},
})

const fetchError = error => ({
  type: actionTypes.OUTLET_STOCKS_FETCH_ERROR,
  payload: {...error},
})

const updateSort = ({
                      key, dir, gtmID, gtmPayload,
                    }) => ({
  type: actionTypes.UPDATE_SORT,
  payload: {sort: {key, dir}, gtmID, gtmPayload},
})

const updateFilters = filter => ({
  type: actionTypes.UPDATE_FILTER,
  payload: {filter},
})

export const actionCreators = {
  initOutletStore,
  dealerReset,
  dealerChangeRequest,
  nameplateChange,
  fetchRequest,
  dealerConfirm,
  fetchSuccess,
  fetchError,
  stepChange,
  updateSort,
  updateFilters,
}

// Selectors

const getOutlet = get('outlet')

export const selectors = {
  getOutlet,
}



// WEBPACK FOOTER //
// ./src/store/actions/outlet.js